import { useRef, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { isValidArray } from "./common";

export const LoadMoreCartItem = ({ orderId, cartItem, totalItem, onItemsLoaded }) => {
  const pageNumber = useRef(1);
  const [showloading, setShowloading] = useState(false);
  const { userId } = useAuth();
  const { getOrderItems } = useGlobalFunction();

  const handleLoadMoreCartItems = async () => {
    if (userId && orderId) {
      setShowloading(true);
      const response = await getOrderItems(orderId, pageNumber.current + 1);
      if (isValidArray(response?.cartItem)) {
        pageNumber.current += 1;
        onItemsLoaded(response.cartItem);
      }
      setShowloading(false);
    }
  };

  if (!cartItem || cartItem.length >= totalItem || totalItem <= 50) return null;

  return (
    <div className="text-center mt-3 quickOrderBtn">
      <div className="button-effect quickShopping">
        <button
          type="button"
          onClick={handleLoadMoreCartItems}
          className="btn btn-products btn-addcart"
          disabled={showloading}
          style={{ width: "200px" }}
        >
          {showloading ? (
            <p>
              <i className="fas fa-spinner fa-spin"></i>Loading Items...
            </p>
          ) : (
            `Load More Items ${cartItem.length} / ${totalItem}`
          )}
        </button>
      </div>
    </div>
  );
};
